export const MASTER_TIMEZONE_REQUEST = "MASTER_TIMEZONE_REQUEST";
export const MASTER_TIMEZONE_SUCCESS = "MASTER_TIMEZONE_SUCCESS";
export const MASTER_TIMEZONE_FAILURE = "MASTER_TIMEZONE_FAILURE";